import api from '../api';
import { addJWT } from '../JWTLegacyService';

const VPAutoService = {
	readOptionsListHowDidYouKnowUs: (userType,config = {}) => {
		return api.get(`/optionsListHowDidYouKnowUsRead`, {
        params: {userType}, ...config
      });
	},
	isUserLegacy : (email, config = {}) => {
		return api.get(`/partIsCustomerLegacy`, {
			params: {email}, ...config
		});
	},
	partLegacyCreate : (data,config = {}) => {
		return api.post( `/partLegacyCreate`,data, config)
	},
	partLegacyMigrate : (data,config = {}) => {
		return api.post( `/partLegacyMigrate`,data, config)
	}
};

export default VPAutoService;
